<template>

	<div>
		<transition name="fade">
			<div v-bind:key="registred">

				<registrationForm v-if="!registred" :callback="function(ret){ registred = true; }" />
				<registrationSuccess v-else/>

			</div>
		</transition>
	</div>

</template>

<script>

import registrationForm from '@core/components/content/app/registration/form'
import registrationSuccess from '@core/components/content/app/registration/success'

export default{

  components: {registrationForm, registrationSuccess},

  data () {
    return {
      registred: false
    }
  }

}

</script>
